var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { DefaultButton, Icon, Stack, concatStyleSets, useTheme } from "@fluentui/react";
import React from "react";
import { Text } from "../../generic/Text/Text";
import { getDisplayFlex } from "../EvolvedSettingsDialog.styles";
import { getActionDescriptionStyles, getActionMainButtonStyle, getActionTitleStyles, getContentAreaStackStyle, getIconStackStyle, getIconStyle } from "./EvolvedSettingsAction.styles";
// A Expand/Collapse UX Component for the DMA Settings Work.
const EvolvedSettingsAction = React.memo((_a) => {
    var { id, styles, iconName, icon, title, description, descriptionNodes, actionNode, isMultiLine = false, isSubElement = false } = _a, rest = __rest(_a, ["id", "styles", "iconName", "icon", "title", "description", "descriptionNodes", "actionNode", "isMultiLine", "isSubElement"]);
    const theme = useTheme();
    return React.createElement(DefaultButton, Object.assign({ uniqueId: id, styles: getDisplayFlex(concatStyleSets(getActionMainButtonStyle(theme), styles)) }, rest),
        React.createElement(Stack.Item, { styles: getDisplayFlex(getIconStackStyle(isMultiLine, isSubElement)) }, icon !== null && icon !== void 0 ? icon : (React.createElement(Icon, { iconName: iconName, styles: getDisplayFlex(getIconStyle(theme)) }))),
        React.createElement(Stack.Item, { grow: true, styles: getDisplayFlex(getContentAreaStackStyle(theme, isMultiLine)) },
            React.createElement(Stack.Item, { id: "title-" + id },
                React.createElement(Text, { styles: getDisplayFlex(getActionTitleStyles(theme)) }, title)), descriptionNodes !== null && descriptionNodes !== void 0 ? descriptionNodes : (description ? React.createElement(Text, { styles: getDisplayFlex(getActionDescriptionStyles(theme)) }, description) : undefined)),
        actionNode);
});
export default EvolvedSettingsAction;
